import axios from 'axios';
const watclistURL = 'https://watchlist.technosoftja.com/';

export class WatchListService {
  _instance;
  constructor() {
    this._instance = axios.create({
      baseURL: watclistURL
    });
  }

  ConfirmHit(obj) {
    return this._instance.post(`watch-list/person/confirm-hit`, obj);
  }
  getAll() {
    return this._instance.get(`watch-list/person/getall`);
  }
  SearchByType(obj) {
    return this._instance.post(`watch-list/person/search-by-type`, obj);
  }
  GetConfirmHit(active) {
    return this._instance.post(
      `watch-list/person/get-all/confirm-hit?active=${active}`
    );
  }
  DeleteHit(obj) {
    return this._instance.post(`watch-list/person/delete-one/confirm-hit`, obj);
  }
  PepSearchOne(obj) {
    return this._instance.post(`watch-list/person/pep/search-one`, obj);
  }
  IfExist(obj) {
    return this._instance.post(`watch-list/person/if-exist`, obj);
  }
  queryWatchlist(params) {
    return this._instance.post(``, params);
  }
  batchQueryWatchlist(params) {
    return this._instance.post(`batch`, params);
  }
}
